import { ROUTER_NAMES } from '../routerNamesConfig';

export const STAFF_CARD_CONFIG = {
	path: 'staff/:cardId',
	name: ROUTER_NAMES.STAFF.CARD,
	component: () => import('@/views/company/cards/staff/CompanyCardStaffView.vue'),
	children: [
		{
			path: '',
			name: ROUTER_NAMES.STAFF.CARD_TABS.GENERAL,
			component: () => import('@/views/company/cards/staff/tabs/CompanyCardStaffGeneralTabView.vue'),
		},
        {
			path: 'driver_profile',
			name: ROUTER_NAMES.STAFF.CARD_TABS.DRIVER_PROFILE,
			component: () => import('@/views/company/cards/staff/tabs/CompanyCardStaffDriverProfileTabView.vue'),
		},
		{
			path: 'tasks_and_jobs',
			name: ROUTER_NAMES.STAFF.CARD_TABS.TASKS_AND_JOBS,
			component: () => import('@/views/company/cards/staff/tabs/CompanyCardStaffTasksJobsTabView.vue'),
		},
		{
			path: 'resources',
			name: ROUTER_NAMES.STAFF.CARD_TABS.RESOURCES,
			component: () => import('@/views/company/cards/staff/tabs/CompanyCardStaffResourcesTabView.vue'),
		},
		{
			path: 'salary',
			name: ROUTER_NAMES.STAFF.CARD_TABS.SALARY,
			component: () => import('@/views/company/cards/staff/tabs/CompanyCardStaffSalaryTabView.vue'),
		},
		{
			path: 'incidents',
			name: ROUTER_NAMES.STAFF.CARD_TABS.INCIDENTS,
			component: () => import('@/views/company/cards/staff/tabs/CompanyCardStaffIncidentsTabView.vue'),
		},

	]
}
